import React from 'react';
import { Button } from './ui/Button';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-[#F0F9F4] py-24 overflow-hidden" data-id="element-293">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        <div className="flex flex-col lg:flex-row items-center" data-id="element-295">
          <div className="w-full lg:w-1/2 mb-12 lg:mb-0" data-id="element-296">
            <div className="bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-md mb-8 border-2 border-[#00A862]" data-id="element-297">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-298">
                Transform your classroom into a{' '}
                <span className="text-[#00A862]" data-id="element-299">
                  collaborative learning hub
                </span>
              </h1>
              <p className="text-xl text-gray-600 mb-8 max-w-lg" data-id="element-300">
                Nexio App helps educators gather lesson ideas, share study
                resources, and collect peer feedback — creating learning
                environments where every voice contributes.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-301">
              <Button size="lg" className="min-w-[180px] shadow-md" href="https://nexioapp.eu/dashboard/register" data-id="element-302">
                Start for free
              </Button>
              <Button variant="outline" size="lg" className="min-w-[180px]" href="https://calendar.app.google/6fKsGXEmBQzjPvnc9" data-id="element-303">
                Schedule a Demo
                <ArrowRightIcon className="ml-2" size={16} data-id="element-304" />
              </Button>
            </div>
          </div>
          <div className="w-full lg:w-1/2" data-id="element-305">
            <div className="relative" data-id="element-306">
              <div className="bg-white rounded-xl shadow-xl p-4 transform transition-transform hover:scale-[1.02] duration-300 border-2 border-[#00A862]" data-id="element-307">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1curTRZVzRzHPzRKqGu1uj/Schermafbeelding_2025-08-30_140602.png" alt="Educational collaboration platform" className="rounded-lg w-full shadow-sm" data-id="element-308" />
                <div className="absolute -bottom-6 -left-6 bg-white rounded-lg shadow-lg p-4 w-48 border border-[#00A862] transform transition-transform hover:scale-105 duration-300" data-id="element-309">
                  <div className="flex items-center space-x-2 mb-2" data-id="element-310">
                    <div className="w-2 h-2 rounded-full bg-[#00A862]" data-id="element-311"></div>
                    <span className="text-sm font-medium" data-id="element-312">
                      New lesson idea shared
                    </span>
                  </div>
                  <p className="text-xs text-gray-500" data-id="element-313">
                    From teacher to curriculum in seconds
                  </p>
                </div>
                <div className="absolute -top-6 -right-6 bg-white rounded-lg shadow-lg p-4 w-48 border border-[#00A862] transform transition-transform hover:scale-105 duration-300" data-id="element-314">
                  <div className="flex items-center space-x-2 mb-2" data-id="element-315">
                    <div className="w-2 h-2 rounded-full bg-[#00A862]" data-id="element-316"></div>
                    <span className="text-sm font-medium" data-id="element-317">
                      23 study resources
                    </span>
                  </div>
                  <p className="text-xs text-gray-500" data-id="element-318">
                    Organized and ready to share
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}